import {init} from "@sentry/react";

import {MODE} from "../../gitIgnore/appMode";

const sentryDsn =
  // "https://0ad2276fc32d0dc30994632470e7b978@o4511529657827328.ingest.de.sentry.io/4511529667985488";
  "https://tELYbumi6XBryrbaiUrSPyzj@s2520424.eu-fsn-3.betterstackdata.com/2520424";

init({
  dsn: sentryDsn,
  enabled: Boolean(sentryDsn),
  sendDefaultPii: false,
  enableLogs: false,
  environment: MODE,
  sampleRate: 1, //! USE 0.2 - 0.5 to optimize error handling, but now all good, DON'T TOUCH
  tracesSampleRate: 0, //  (1.0) Capture 100% of the transactions
  replaysSessionSampleRate: 0, // (0.1) This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0, // (1.0) If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  ignoreErrors: [
    "Cannot access 'user' before initialization",
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
    "Non-Error promise rejection captured",
    "Network Error",
    "Failed to fetch",
  ],
  beforeSend(event, hint) {
    if (window.location.hostname === "localhost") {
      return null;
    }
    const originalException = hint?.originalException;
    const message =
      (originalException && originalException.message) || event?.message || event?.exception?.values?.[0]?.value || "";

    if (/network error|failed to fetch|load failed/i.test(String(message))) {
      return null;
    }

    if (/cannot access '?.+?'? before initialization/i.test(String(message))) {
      return null;
    }

    return event;
  },
});

//!test
// const container = document.getElementById("app");
// const root = createRoot(container);
// root.render(<App />);
